import { FC } from 'react';
import {
  RiskDetailsInfoLite,
  RiskDetailsInfo,
  RiskDetailsSignalsFull,
} from '@/components';
import { AmlHistoryItemData } from '@/redux/models';
import { isFlowLite } from '@/helpers';
import styles from './RiskSignalDetails.module.sass';

interface RiskSignalDetailsProps {
  isLimitedMode: boolean;
  hasSignals: boolean;
  item: AmlHistoryItemData;
}

const RiskSignalDetails: FC<RiskSignalDetailsProps> = (props) => {
  const { isLimitedMode = false, hasSignals, item } = props;
  const isLiteFlow = isFlowLite(item.flow);

  return (
    <div className={styles.details}>
      {isLimitedMode && (
        <>
          {isLiteFlow && (
            <RiskDetailsInfoLite item={item} hasSignals={hasSignals} />
          )}
          {!isLiteFlow && <RiskDetailsInfo item={item} />}
        </>
      )}

      {!isLimitedMode && <RiskDetailsSignalsFull item={item} />}
    </div>
  );
};

export default RiskSignalDetails;
